import React from "react";
import PropTypes from "prop-types";
// Material imports
import { ThemeProvider } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import VerticalTab from "@limitless/modern/navigation/vertical-tabs/VerticalTabs";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useExpertProfileContext } from "@limitless/expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import { useHistory, useLocation } from "react-router-dom";
const useStyles = makeStyles(() => ({
  contentContainer: {
    height: "90vh",
    overflow: "auto",
    width: "calc(100% - 315px)"
  }
}));
const SettingsTabs = ({
  tabsLabels,
  tabsContent,
  selectedTab = 0
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(selectedTab);
  const {
    isDarkMode
  } = useExpertProfileContext();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabKey = queryParams.get("tab");
  React.useEffect(() => {
    if (tabKey) {
      const tabIndex = tabsLabels.findIndex(item => item.id === tabKey);
      if (tabIndex !== -1) {
        setSelectedTabIndex(tabIndex);
      }
    }
  }, [tabKey]);
  const classes = useStyles();
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  const handleChangeTab = (event, newValue) => {
    setSelectedTabIndex(newValue);
    const selectedTab = tabsLabels[newValue];
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", selectedTab.id);
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };
  const renderTabContent = React.useMemo(() => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      color: theme => theme.palette.primary.dark
    }
  }, tabsLabels[selectedTabIndex].label), tabsContent[selectedTabIndex]), [selectedTabIndex]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    sx: {
      backgroundColor: theme => theme.palette.background.default
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(VerticalTab, {
    items: tabsLabels,
    value: selectedTabIndex,
    onChange: handleChangeTab
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: "40px 48px",
      margin: "40px 0px",
      maxWidth: "646px"
    }
  }, renderTabContent))));
};
export default SettingsTabs;
SettingsTabs.propTypes = {
  tabsLabels: PropTypes.array.isRequired,
  tabsContent: PropTypes.array.isRequired,
  selectedTab: PropTypes.number
};